import React, { useEffect, useRef, useState } from "react";
import styles from "./Popup.module.css";

function Popup({ onClose, children, className, contentClassName }) {
  const popupRef = useRef();

  const [style, setStyle] = useState({});

  const handleClose = (e) => {
    const ele = document.querySelector(`.${styles.content}`);
    if (!ele?.contains(e.target)) {
      onClose?.();
    }
  };

  useEffect(() => {
    window.addEventListener("click", handleClose);

    return () => window.removeEventListener("click", handleClose);
  }, []);

  useEffect(() => {
    let position = popupRef.current?.getBoundingClientRect();
    let styleObj = {}
    if (position.top <= 0) {
      styleObj = {top: 20} 
    }
    if(position.right >= (window?.innerWidth || document?.documentElement?.clientWidth)){
      const percentage = parseInt(((position.right - position.width) / window?.innerWidth) * 100)
      styleObj['transform'] = `translateX(-${percentage}%)`
    }
    setStyle(styleObj)
  }, []);

  return (
    <div
      ref={popupRef}
      className={`${styles.popup} ${className}`}
      style={{ ...style }}
    >
      {/* <div className={styles.backdrop} onClick={() => onClose?.()}></div> */}
      <div className={`${styles.content} ${contentClassName}`}>{children}</div>
    </div>
  );
}

export default Popup;
